import"./jbTheme.css.ts.vanilla.css";var e="jbTheme_jbTheme__180xeut0";export{e as jbTheme};
//# sourceMappingURL=jbTheme.css.vanilla.js.map
